const baseURL = process.env.VUE_APP_BASE_API || (process.env.NODE_ENV === 'production' ? '' : '/dev-api')
const ossCustomHttpsDomain = 'https://file.senbolepower.com'
const ossDomainPattern = /https?:\/\/file\.senbolepower\.com|https:\/\/senbolepower\.oss-cn-beijing\.aliyuncs\.com/g

function buildUrl(url, params) {
  const target = `${baseURL}${url}`
  if (!params) {
    return target
  }
  const search = Object.keys(params)
    .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&')
  return search ? `${target}?${search}` : target
}

export function get(url, params) {
  return fetch(buildUrl(url, params), {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  }).then(response => {
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`)
    }
    return response.json()
  }).then(data => {
    if (data.code && data.code !== 200) {
      throw new Error(data.msg || '接口请求失败')
    }
    return normalizeOssUrls(data)
  })
}

export function resolveFileUrl(url, fallback) {
  if (!url) {
    return fallback || ''
  }
  const normalizedUrl = normalizeOssUrls(url)
  if (/^(https?:)?\/\//.test(url) || url.indexOf('data:') === 0) {
    return normalizedUrl
  }
  const prefix = baseURL || ''
  const normalized = normalizedUrl.charAt(0) === '/' ? normalizedUrl : `/${normalizedUrl}`
  return `${prefix}${normalized}`
}

export function normalizeOssUrls(value) {
  if (typeof value === 'string') {
    return value.replace(ossDomainPattern, ossCustomHttpsDomain)
  }
  if (Array.isArray(value)) {
    return value.map(item => normalizeOssUrls(item))
  }
  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((target, key) => {
      target[key] = normalizeOssUrls(value[key])
      return target
    }, {})
  }
  return value
}
